<template>
    <!--  autocomplete="new-password" is to disable autofill on other fields as otherwise changes are not detected -->
    <div ref="root">
      <input
        v-bind="$attrs"
        autocomplete="new-password"
        v-showLargeInputs
        :type="inputType"
        :id="inputId"
        :name="name"
        :value=value
        :step="step"
        :min="min"
        :max="max"
        :placeholder=placeholderText
        :class="[$vnode.data.staticClass, $vnode.data.class, classNames]"
        :style=styleNames
        @click="getValue($event.target.value)"
        v-on=" useDebounce 
          ? {
            blur: onEventBlurDebounce,
            input: onInputChangeDebounce
          }
          : {
            blur: onEventBlur,
            input: onInputChange
          }
        "
        @keyup.enter="$event.target.blur()"
        :readonly="readOnly"
        ref="input"
      />
      <span v-if="clearable" class="clear px-3 cursor-pointer" @click="$emit('clear')">
        <i class="fas fa-times"></i>
      </span>
      <slot name="afterField" />
    </div>
</template>
<script>
import _ from 'lodash';
import {randomId} from "../../helpers/randomId";
import showLargeInputs from '../../directives/input-hover';

export default {
    inheritAttrs: false,
    name:'input-text',

    props: {
        inputType: { type: String, default: "text" },
        id: String,
        name: { type: String, default: null },
        value: { type: [String, Number, Array]},
        decimalPoints: Number,
        step: { type: [Number, String] },
        min: { type: Number},
        max: { type: Number},
        digits: { type: Number },
        placeholder: { type: String},
        translatePlaceholder: { type: String },
        classNames: { type: String},
        styleNames: { type: [String, Object]},
        parameters: { type: Object , default: null},
        readOnly: { type: Boolean, default: false},
        onChange: { type: Function, default: () => null },
        onBlur: { type: Function, default: () => null },
        onBlurOnly: Boolean,
        checkOldValue: {
          type: Boolean,
          default: true
        },
        useDebounce: {
          type: Boolean,
          default: true
        }
    },

    mounted () {
      // Force ignore parent class attribute binding
      this.$refs.root.className = 'd-flex w-100 align-items-center';
    },

    methods: {
      processValue(value) {
        if(this.inputType === 'number' && !this.numberIsNotEmpty(value)) {
            if(this.max < parseInt(value)) value = this.max
            if(this.min > parseInt(value)) value = this.min
            if(this.decimalPoints) value = parseFloat(value)
            else value = parseInt(value)

            if (this.digits) {
              value = ((Array(2).fill("0").reduce((acc, value) => acc + value, "")) + value).slice(this.digits * -1);
              if (this.$refs.input) {
                this.$refs.input.value = value;
              }
            }
        }
        return value;
      },
      numberIsNotEmpty(value) {
        return isNaN(value) || value == ''
      },

      getValue(value){
        this.oldValue = this.processValue(value);
      },

      updateCode(value) {
        this.newValue = value;
        this.$emit('input', value);
      },

      onEventBlur(event){
        this.eventBlur(event);
      },

      onEventBlurDebounce: _.debounce(function (event) {
        this.eventBlur(event)
      }, 500),

      eventBlur(event){
        const value = this.processValue(event.target.value);
        
        if (!this.checkOldValue || this.oldValue != value){
          this.newValue = value;
          let valueFinal;
          if (this.parameters == null){
            valueFinal = value;
          } else {
            this.parameters['value'] = value;
            valueFinal = this.parameters;
          }
          this.$emit('onEventBlur', valueFinal);
          this.onBlur(value);
          if(this.onBlurOnly) this.onChange(value)
        }
      },

      onInputChange(event){
        this.inputChange(event)
      },

      onInputChangeDebounce: _.debounce(function (event) {
        this.inputChange(event)
      }),

      inputChange(event){
        const value = this.processValue(event.target.value);
        this.updateCode(value);
        if(!this.onBlurOnly) this.onChange(value);
      },
      
    },

    data () {
      return {
        oldValue: null,
        newValue: null,
      }
    },

    computed: {
      inputId() { return this.id ? this.id : randomId('input-text')},
      placeholderText() { return this.translatePlaceholder ? this.$t(this.translatePlaceholder) : this.placeholder },
      clearable () { return typeof this.$listeners.clear === 'function'; }
    },

    directives: {
    showLargeInputs
  },
}
</script>

<style lang="scss" scoped>
  input {
    width: 100%;
    border: none;
    text-overflow: ellipsis;
    font-size: inherit;

    & + .clear {
      opacity: 0.6;
      font-size: 12px;

      &:hover {
        opacity: 1;
      }
    }
  }
</style>